module.exports = __webpack_public_path__ + "img/store-huawei-es.441a26c.png";